// encrypted-storage.service.ts
import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
// import { environment } from '@env/environment.prod';
import { environment } from '@env/environment';
@Injectable({ providedIn: 'root' })
export class EncryptedStorageService {
  public secretKey = environment.secretKey || 'e3oLHbJDQ+j6`VD-FB-Ze[Z&y7R)Y~!';

  public encrypt(value: string): string {
    return CryptoJS.AES.encrypt(value, this.secretKey).toString();
  }

  public decrypt(cipherText: string): string {
    try {
      const bytes = CryptoJS.AES.decrypt(cipherText, this.secretKey);
      return bytes.toString(CryptoJS.enc.Utf8);
    } catch {
      return '';
    }
  }

  setItem(key: string, value: any): void {
    key = JSON.stringify(key);
    const stringValue = JSON.stringify(value);
    const encryptedValue = this.encrypt(stringValue);
    setTimeout(() => {
      localStorage.setItem(window.btoa(key), encryptedValue);
    });
  }

  getItem<T>(key: string): T | null {
    key = JSON.stringify(key);
    key = window.btoa(key);
    const storedValue = localStorage.getItem(key);
    if (!storedValue) return null;
    const decrypted = this.decrypt(storedValue);
    try {
      return JSON.parse(decrypted) as T;
    } catch {
      return null;
    }
  }

  removeItem(key: string): void {
    key = JSON.stringify(key);
    key = window.btoa(key);
    localStorage.removeItem(key);
  }

  clear(): void {
    localStorage.clear();
  }
}
